import { Observable } from "rxjs";
import { ContactRequestSendCommand, ContactRequestSendCommandResult } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export abstract class IContactRequestService {
  abstract contactRequestSend(contactRequestSendCommand: ContactRequestSendCommand): Observable<ContactRequestSendCommandResult>
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IContactRequestServiceToken = new InjectionToken<IContactRequestService>('IContactRequestServiceToken');
